import React from "react";
import CommonModal from "./CommonModal";

const STATUS_LABELS = {
  0: "Rejected",
  1: "Pending",
  2: "Accepted",
  3: "Completed",
  4: "No Show",
};

/**
 * Every past booking for one phone number, latest first — reuses the already-fetched
 * TableView records (no separate API call) since that list already covers this restaurant's
 * full reservation history.
 */
const CustomerBookingHistoryModal = ({ isOpen, onClose, mobile, bookings }) => {
  return (
    <CommonModal isOpen={isOpen} onClose={onClose} elId="customerBookingHistoryModal">
      <div className="modal-header">
        <h5 className="modal-title">Booking History — {mobile}</h5>
        <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
      </div>

      <div className="modal-body">
        <div className="table-responsive">
          <table className="table tableStyle2 table-borderless align-middle">
            <thead>
              <tr>
                <th>Name</th>
                <th>Event</th>
                <th>Date Time</th>
                <th>Guest</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {(bookings || []).map((r) => (
                <tr key={r.id}>
                  <td>{r.first_name} {r.last_name}</td>
                  <td>{r.event}</td>
                  <td>{r.date} {r.time}</td>
                  <td>{r.guests}</td>
                  <td>{STATUS_LABELS[r.status] ?? r.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </CommonModal>
  );
};

export default CustomerBookingHistoryModal;
